import { combineReducers, Reducer } from 'redux';
import { IAppState } from './types';
// import authReducer from './auth/reducer';
import authReducer from './auth/reducer';
import dsConfigReducer from './dsconfig/reducer';
import templatesReducer from './templates/reducer';
import parsedTreesReducer from './parsedTrees/reducer'
import designsReducer from './designs/reducer';
import foldersReducer from './folders/reducer';
import userFilesReducer from './userFiles/reducer';
import userConfigReducer from './userConfig/reducer';
import storageReducer from './storage/reducer';
import OpenMenuReducer from './openReducers/openMenuReducer';
import OpenNewTemplateReducer from './openReducers/openNewTemplateReducer';
import ShowSnackbarReducer from './openReducers/showSnackbarReducer';
import ReloadListReducer from './openReducers/reloadListReducer';
import dealerReducer from './dealers/reducer';
import brandsReducer from './brands/reducer';
import brandsImagesReducer from './brandsImages/reducer';
import userAccessReducer from './userAccess/reducer';
import industriesReducer from './industries/reducer';

const allReducers: Reducer<IAppState> = combineReducers({
  auth: authReducer,
  dsConfig: dsConfigReducer,
  templates: templatesReducer,
  parsedTrees: parsedTreesReducer,
  designs: designsReducer,
  folders: foldersReducer,
  userFiles: userFilesReducer,
  userConfig: userConfigReducer,
  storage: storageReducer,
  openMenuState: OpenMenuReducer,
  openNewTemplateState: OpenNewTemplateReducer,
  showSnackBar: ShowSnackbarReducer,
  reloadListState: ReloadListReducer,
  dealers: dealerReducer,
  brands: brandsReducer,
  brandsImages: brandsImagesReducer,
  userAccess: userAccessReducer,
  industries: industriesReducer,
});

export default allReducers;
